import Glide from '@glidejs/glide';
import Sizes from '../../shared/glide_fixed_width_slides';

const customTables = document.querySelectorAll('table[data-is-sticky-table]');

/**
 * Fallback method to move up the tree and find the table's div.table-wrapper ancestor
 *
 * @param {HTMLElement} element - the table element from where to begin tree traversal
 * @returns {HTMLElement} the first element with .table-wrapper class
 */
const getTableWrapperEl = (element) => {
  let targetElement = null;

  if (element.parentElement === document.body) return null;

  if (element.classList.contains('table-wrapper')) {
    return element;
  } else {
    targetElement = getTableWrapperEl(element.parentElement);
  }

  return targetElement;
};

/**
 * Determines whether gradient on right side of table should be added
 *
 * @param {HTMLElement} table - the target table element
 * @returns {void}
 */
const addGradientIfAppropriate = (table, first = false) => {
  const tableParent = table.parentElement;
  const tableWrapperEl = table.offsetParent?.classList.contains('table-wrapper')
    ? table.offsetParent
    : getTableWrapperEl(table);
  tableWrapperEl.classList.remove('table-no-overflow');
  tableWrapperEl.classList.remove('table-overflow');

  const tableHeight = table.offsetHeight;
  const tableWidth = table.offsetWidth;
  const wrapperWidth = tableWrapperEl.offsetWidth;

  if (tableWidth > wrapperWidth + 25) {
    tableWrapperEl.classList.add('table-overflow');
    tableWrapperEl.classList.remove('table-no-overflow');
  } else {
    tableWrapperEl.classList.add('table-no-overflow');
    tableWrapperEl.classList.remove('table-overflow');
  }

  if (tableWidth > wrapperWidth) {
    if (first) {
      tableWrapperEl.classList.add('not-fully-scrolled');
    }

    tableWrapperEl.style.setProperty(
      '--tableHeightMinusScrollbar',
      `${tableHeight}px`,
    );

    if (!tableParent.dataset.listenerAdded) {
      tableParent.addEventListener('scroll', (e) => {
        const maxScroll = Math.abs(
          Math.floor(e.target.offsetWidth - table.offsetWidth),
        );
        const currentScroll = e.target.scrollLeft;
        const scrollThreshold = Math.floor(maxScroll - 40); // width of gradient
        const maxGradientStop = 100;
        let prevScroll = parseInt(e.target.dataset.prevScroll);
        let gradientStop = parseInt(e.target.dataset.gradientStop);

        const scrollDirection = currentScroll > prevScroll ? 'right' : 'left';

        if (currentScroll >= scrollThreshold) {
          switch (scrollDirection) {
            case 'right':
              if (gradientStop <= maxGradientStop) {
                e.target.dataset.gradientStop = gradientStop + 5;
              }
              break;
            case 'left':
              if (gradientStop >= 0) {
                e.target.dataset.gradientStop = gradientStop - 5;
              }
              break;
          }

          tableWrapperEl.style.setProperty(
            '--gradientStop',
            `${gradientStop}%`,
          );

          if (currentScroll >= maxScroll - 5) {
            tableWrapperEl.style.setProperty('--gradientStop', '100%');
            tableWrapperEl.classList.add('fully-scrolled');
            tableWrapperEl.classList.remove('not-fully-scrolled');
          } else {
            tableWrapperEl.classList.add('not-fully-scrolled');
            tableWrapperEl.classList.remove('fully-scrolled');
          }

          e.target.dataset.prevScroll = currentScroll;
        } else {
          tableWrapperEl.style.setProperty('--gradientStop', '0%');
          tableWrapperEl.classList.add('not-fully-scrolled');
          tableWrapperEl.classList.remove('fully-scrolled');
          e.target.dataset.gradientStop = 0;
        }
      });

      tableParent.dataset.listenerAdded = true;
    }
  }
};

const checkForGradientsOnWindowResize = () => {
  // Will call the function only once per second max.
  if (!window.resizeInProgress) {
    window.resizeInProgress = true;
    setTimeout(() => {
      let resizedCustomTables = document.querySelectorAll(
        'table[data-is-sticky-table]',
      );
      resizedCustomTables.forEach((table) => {
        addGradientIfAppropriate(table);
      });
      window.resizeInProgress = false;
    }, 500);
  }
};

// Set initial data attribute values
customTables.forEach((table) => {
  const tableParent = table.parentElement;
  tableParent.dataset.prevScroll = 0;
  tableParent.dataset.gradientStop = 0;
  addGradientIfAppropriate(table, true);
});

window.addEventListener('resize', checkForGradientsOnWindowResize);

const options = {
  type: 'carousel',
  startAt: 0,
  perView: 4,
  gap: 20,
  peek: {
    before: -10,
    after: 20,
  },
  breakpoints: {
    1024: {
      perView: 3,
      peek: {
        before: -10,
        after: 40,
      },
    },
    650: {
      perView: 2,
      peek: {
        before: -10,
        after: 32,
      },
    },
    450: {
      perView: 1,
      peek: {
        before: 0,
        after: 32,
      },
    },
  },
};

const blogArticleSlider = document.querySelector(
  '.blog-related-articles-slider__slider.glide',
);

if (blogArticleSlider) {
  const relatedPostsSlider = new Glide(blogArticleSlider, options);
  relatedPostsSlider.mount(Sizes);
}
